// /team — «Просрочено у ваших сотрудников» (032: T028; FR-021, FR-022; ASG-FLOW-04): просроченные
// пункты людей руководителя, только чтение. Право — items.team («в сеансе»): какие люди — решает
// сервер (team.overdue); без связи с человеком или не руководителю страница говорит об этом сама.
// Сюда ведут пункт меню (me.team) и вход по ссылке из письма руководителю (next: '/team').
import { createFileRoute } from '@tanstack/react-router';
import { TeamPage } from '../../features/team/TeamPage.tsx';

export const Route = createFileRoute('/_app/team')({
  staticData: { crumb: 'Просрочено у ваших сотрудников' },
  component: TeamPage,
});
